import { render } from "./NewsCapital.vue?vue&type=template&id=20693be8&scoped=true"
import script from "./NewsCapital.vue?vue&type=script&lang=js"
export * from "./NewsCapital.vue?vue&type=script&lang=js"

import "./NewsCapital.vue?vue&type=style&index=0&id=20693be8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20693be8"]])

export default __exports__